import React, { useContext, createContext } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

const GravityFormsContext = createContext();

export const GravityFormsProvider = ({ children }) => {
    const {
        allWpGfForm: { nodes: forms },
        wp
    } = useStaticQuery(graphql`
        query GravityFormQuery {
            allWpGfForm {
                nodes {
                    ...GravityFormFields
                }
            }
            wp {
                ...GravityFormSettings
            }
        }
    `);
    return (
        <GravityFormsContext.Provider value={{ forms, wp }}>
            {children}
        </GravityFormsContext.Provider>
    );
};

export const useGravityFormsContext = () => useContext(GravityFormsContext);
